<div class="main-grid">
  <ng-container *ngFor="let item of coursesSkeletonPlaceholder">
    <en-course-card-skeleton></en-course-card-skeleton>
  </ng-container>
</div>
